import { AUTHENTICATION, PASDWORDREGEX, ValidationHelper } from "../constants";
import AWS from "aws-sdk";

export const SessionStorageData = () => {
    let data = sessionStorage.getItem(AUTHENTICATION.SHARED.ACCESS_TOKEN) || "{}";
    return Object.values(data).length > 3 ? true : false;
};

/** store data in session storage */
export const SetSessionStorageData = (sessionKey: string, payload: any) => {
    return sessionStorage.setItem(sessionKey, payload);
};

/** get data from session storage */
export const GetSessionStorageData = (sessionKey: string) => {
    return sessionStorage.getItem(sessionKey);
};
/** check for null, undefined and empty value */
export const nullUndefinedEmptyCheck = (data: any) => {
    return data !== null && data !== undefined && data !== "";
};
/** check for null value */
export const nullCheck = (data: any) => {
    return data !== null;
};

/* To clear session storage */
export const clearSessionStorage = () => {
    return sessionStorage.clear();
};

/**empty length check */
export const checkEmpty = (data: any): boolean => {
    return data.length !== 0;
};

/**Upload files to S3 bucket */
export const uploadFileToS3 = (file: any, key: any) => {
    return new Promise((resolve, reject) => {
        AWS.config.update({
            accessKeyId: key?.access_key,
            secretAccessKey: key?.secret_access_key,
            region: process.env.REACT_APP_S3_REGION,
        });

        const s3 = new AWS.S3();
        const params: any = {
            Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
            Key: file.name,
            Body: file,
            ACL: "public-read",
            ContentType: file?.type,
        };

        s3.upload(params, (err: any, data: any) => {
            if (err) {
                reject(err);
            } else {
                resolve(data.Location);
            }
        });
    });
};



//validate input fields
export const validateInput = (targetName: any, targetValue: any) => {
    if (targetName == 'email') {
        if (!ValidationHelper.isNotEmpty(targetValue)) {
            return {
                error: { [targetName]: true, ['class' + targetName]: 'valid' },
                errorMsg: { [targetName]: 'Email required' }
            }
        }
        if (!ValidationHelper.isEmail(targetValue)) {
            return {
                error: { [targetName]: true, ['class' + targetName]: 'invalid' },
                errorMsg: { [targetName]: 'Invalid email' }
            }
        } else {
            return {
                error: { [targetName]: false, ['class' + targetName]: 'valid' },
                errorMsg: { [targetName]: null }
            }
        }

    } else if (targetName == 'password') {
        if (!ValidationHelper.isNotEmpty(targetValue)) {
            return {
                error: { [targetName]: true, ['class' + targetName]: 'invalid' },
                errorMsg: {
                    [targetName]: 'password required'
                }
            }
        }

        if (!ValidationHelper.checkMinLength(targetValue, 8)) {
            return {
                error: { [targetName]: true, ['class' + targetName]: 'invalid' },
                errorMsg: { [targetName]: 'minimum 8 character' }
            }
        }

        if (!PASDWORDREGEX.test(targetValue)) {
            return {
                error: { [targetName]: true, ['class' + targetName]: 'invalid' },
                errorMsg: { [targetName]: 'Password must contain at least one capital letter and one special character' }
            }
        }


        if (!ValidationHelper.checKCharLimit(targetValue, 1, 16)) {
            return {
                error: { [targetName]: true, ['class' + targetName]: 'invalid' },
                errorMsg: { [targetName]: "maximum 16 characters" }
            }
        }
        else {
            return {
                error: { [targetName]: false, ['class' + targetName]: 'valid' },
                errorMsg: { [targetName]: null }
            }
        }
    }
    if (targetName == 'confirm_password') {
        if (!ValidationHelper.isNotEmpty(targetValue)) {
            return {
                error: { [targetName]: true, ['class' + targetName]: 'invalid' },
                errorMsg: {
                    [targetName]: 'confirm password required'
                }
            }
        } else {
            return {
                error: { [targetName]: false, ['class' + targetName]: 'valid' },
                errorMsg: { [targetName]: null }
            }
        }
    }

}